import VueLogger from "vuejs-logger";
import Vue from "vue";
const isProduction = process.env.NODE_ENV === "production";

const options = {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: false,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true
};

Vue.use(VueLogger, options);



// WEBPACK FOOTER //
// ./src/js/loggerHelper.js